// extracted by mini-css-extract-plugin
export var sticky = "list-item-modules--sticky--33GFA";
export var year = "list-item-modules--year--3udPG";
export var carousel = "list-item-modules--carousel--2In0L";
export var plain = "list-item-modules--plain--mggMk";
export var quote = "list-item-modules--quote--1zpho";
export var quoteSource = "list-item-modules--quoteSource--1qPvb";